// src/App.js
import React, { useState, useRef, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
const SITE_KEY       = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

function App() {
  const [fullPhone, setFullPhone] = useState('');
  const [otp, setOtp]             = useState('');
  const [sessionInfo, setSessionInfo] = useState('');
  const [status, setStatus]       = useState('');
  const [sending, setSending]     = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [verifyEnabled, setVerifyEnabled] = useState(false);
  const recaptchaRef = useRef(null);

  // 計時器倒數
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => setCountdown(c => c - 1), 1000);
    } else {
      setSending(false);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  // 按「發送短信驗證碼」
  const startSend = () => {
    if (!fullPhone) return setStatus('請先輸入手機號');
    setStatus(''); setSending(true); setCountdown(60);
    recaptchaRef.current.execute();
  };

  // reCAPTCHA 成功
  const onReCAPTCHASuccess = async token => {
    try {
      const res = await fetch(
        `https://www.googleapis.com/identitytoolkit/v3/relyingparty/sendVerificationCode?key=${FIREBASE_API_KEY}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            phoneNumber: fullPhone,
            recaptchaToken: token
          })
        }
      );
      const data = await res.json();
      if (data.sessionInfo) {
        setSessionInfo(data.sessionInfo);
        setVerifyEnabled(true);
        setStatus('OTP 已發送');
      } else {
        setStatus(`發送失敗：${data.error?.message || '未知錯誤'}`);
      }
    } catch {
      setStatus('Network error');
    }
  };

  // 按「驗證」
  const handleVerify = async () => {
    if (!otp) return setStatus('請輸入 OTP');
    setStatus('');
    try {
      const res = await fetch(
        `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPhoneNumber?key=${FIREBASE_API_KEY}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionInfo, code: otp })
        }
      );
      const data = await res.json();
      if (data.idToken) {
        setStatus('驗證成功');
      } else {
        setStatus(`驗證失敗：${data.error?.message || '未知錯誤'}`);
      }
    } catch {
      setStatus('Network error');
    }
  };

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial', fontSize: '1.25rem' }}>
      <div>
        <label>手機號:</label>
        <input
          type="tel"
          value={fullPhone}
          onChange={e => setFullPhone(e.target.value)}
          placeholder="+886912345678"
          style={{ marginLeft: '0.5rem', width: '60%' }}
        />
        <button onClick={startSend} disabled={sending} style={{ marginLeft: '1rem' }}>
          {sending ? `再發送 (${countdown}s)` : '發送短信驗證碼'}
        </button>
      </div>
      <div style={{ marginTop: '1rem' }}>
        <label>請輸入短信驗證碼:</label>
        <input
          type="text"
          value={otp}
          onChange={e => setOtp(e.target.value)}
          placeholder="輸入 OTP"
          style={{ marginLeft: '0.5rem' }}
        />
        <button onClick={handleVerify} disabled={!verifyEnabled} style={{ marginLeft: '1rem' }}>
          驗證
        </button>
      </div>
      {status && <div style={{ marginTop: '1rem', color: 'red' }}>{status}</div>}

      <ReCAPTCHA
        sitekey={SITE_KEY}
        size="invisible"
        ref={recaptchaRef}
        onChange={onReCAPTCHASuccess}
      />
    </div>
  );
}

export default App;
